/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Theme } from '@coursera/cds-core';
import { Typography, Typography2, useTheme } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-career-academy';

const valuePropBanner = (theme: Theme) =>
  css({
    padding: '24px',
    background: 'var(--cds-color-grey-50)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: '8px',
    marginTop: '32px',
  });

const valuePropSection = css({
  display: 'flex',
  flexDirection: 'column',
});

export type Props = {
  title: string;
  description: string;
  valuePropTitle: string;
  valuePropImg?: React.ReactNode;
};

export const ValuePropBanner: React.FC<Props> = ({ title, description, valuePropTitle, valuePropImg }) => {
  const theme = useTheme();
  return (
    <div css={valuePropBanner(theme)} data-testid="value-prop-banner">
      <div css={{ display: 'flex', justifyContent: 'flex-start', gap: '24px', alignItems: 'center' }}>
        <Typography variant="d2semibold">{_t('75%')}</Typography>
        <div css={{ textAlign: 'start' }}>
          <Typography2 variant="subtitleMedium" component="p" css={{ maxWidth: '660px' }}>
            {title}
          </Typography2>
          <Typography2 component="p" variant="bodySecondary" color="supportText">
            {description}
          </Typography2>
        </div>
      </div>
      <div css={valuePropSection}>
        <Typography2 variant="subtitleMedium" component="p" css={{ textTransform: 'uppercase' }}>
          {valuePropTitle}
        </Typography2>
        {valuePropImg}
      </div>
    </div>
  );
};
